// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"0288f627","236":"899e7c11","323":"145e553a","477":"899e7c11","699":"24fdb67c","847":"0288f627"}[chunkId] + ".chunk.css";
};